import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CalculatorCheck"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.75 22.5H4.50375C3.67359 22.4992 3.00083 21.8264 3 20.9963V2.997C3.00083 2.17057 3.67057 1.50083 4.497 1.5H19.503C20.3294 1.50083 20.9992 2.17057 21 2.997V13.5H19.5V3H4.5V21H12.75V22.5ZM18 19.9425L16.0575 18L15 19.0575L18 22.0575L23.25 16.8075L22.1925 15.75L18 19.9425ZM12.75 17.25H11.25V18.75H12.75V17.25ZM6.75 17.25H8.25V18.75H6.75V17.25ZM17.25 13.5H15.75V15H17.25V13.5ZM11.25 13.5H12.75V15H11.25V13.5ZM8.25 13.5H6.75V15H8.25V13.5ZM15.75 9.75H17.25V11.25H15.75V9.75ZM12.75 9.75H11.25V11.25H12.75V9.75ZM6.75 9.75H8.25V11.25H6.75V9.75ZM17.25 5.25H6.75V7.5H17.25V5.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CalculatorCheck.vue"]]);
